import { Controller } from '@hotwired/stimulus'
import { get, post } from '@rails/request.js'

export default class extends Controller {
  async get ({ params: { url } }) {
    await get(this._url_with_params(url), {
      contentType: 'application/json',
      responseKind: 'turbo-stream'
    })
  }

  async post ({ params: { url } }) {
    await post(url, {
      contentType: 'application/json',
      responseKind: 'turbo-stream',
      body: this._to_request_body(url)
    })
  }

  _to_request_body (url) {
    url = new URL(url)
    const originalParams = new URLSearchParams(url.searchParams.toString())
    const newParams = new URLSearchParams(new FormData(this.element))

    for (const [key, val] of originalParams.entries()) {
      newParams.set(key, val)
    }

    return Object.fromEntries(newParams.entries())
  }

  _url_with_params (url) {
    url = new URL(url)
    const originalParams = new URLSearchParams(url.searchParams.toString())
    const newParams = new URLSearchParams(new FormData(this.element))

    for (const [key, val] of originalParams.entries()) {
      newParams.set(key, val)
    }
    url.search = newParams.toString()
    return url.toString()
  }
}
